/* eslint-disable */
import React, { Component, useState } from "react";
import { Redirect, useHistory, Link } from "react-router-dom";
import AuthService from "../../services/auth-service";
import axios from "axios";
import SessionData from "../../services/session-data";
import logoImage from "../../images/reprolog_logo.png";

const sd = new SessionData();
const API_URL = sd.getBaseURL();

//client login response type
type userLoginType = {
  user: {
    name: string;
    email: string;
    clientId: string;
  };
  tokens: {
    accessToken: string;
    refreshToken: string;
  };
};

export default function ClientLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [clientid, setClientid] = useState("");
  const [login, setLogin] = useState("");
  let history = useHistory();

  //login the user by calling the login  method from auth-service
  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post(
        API_URL + "login",
        {
          username: username,
          password: password,
          clientid: ("DENTAL_" + clientid).toUpperCase().toString(),
        },
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((data) => {
        if (data.status !== 200) throw new Error("Error loggin in");
        //storing token in local storage
        const d: userLoginType = data.data;
        localStorage.setItem("authToken", d.tokens.accessToken);
        localStorage.setItem("clientName", clientid);

        return history.push("/");
      })
      .catch((Error) => {
        return "bad";
      });
  };

  return (
    <div className="container-fluid login-bg">
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex flex-column min-vh-100  align-items-center ">
            <div className="main_logo_client">
              <img src={logoImage} />
              <div className="cloginTitle">
                <h1>Client Login Area</h1>
              </div>
            </div>
            <div className="clientLogin">
              {login ? "Login Successfull" : ""}
              <form>
                <div className="form-group">
                  <label htmlFor="inputClientId">Client Name</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => setClientid(e.target.value)}
                    value={clientid}
                    id="inputClientId"
                    placeholder="client name"
                  ></input>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter email"
                  ></input>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    id="exampleInputPassword1"
                    placeholder="Password"
                  ></input>
                </div>

                <button
                  type="submit"
                  onClick={(e) => handleLogin(e)}
                  className="btn btn-primary btn-lg btn-block"
                >
                  Submit
                </button>

                <p style={{ marginTop: "20px", width: "200px" }}>
                  <Link to="/pass-reset">Forgot Password?</Link>{" "}
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
